import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Menu from "@/components/site/Menu";
import GlutenFree from "@/components/site/GlutenFree";
import Reviews from "@/components/site/Reviews";
import Location from "@/components/site/Location";
import Footer from "@/components/site/Footer";
import MobileCallBar from "@/components/site/MobileCallBar";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;

    const handleAnchorClick = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const hash = link.getAttribute("href");
      if (!hash || hash.length < 2) return;
      const el = document.querySelector(hash);
      if (!el) return;
      e.preventDefault();
      const offset = window.innerWidth >= 640 ? -160 : -124;
      lenis.scrollTo(el, { offset, duration: 1.2 });
    };
    document.addEventListener("click", handleAnchorClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", handleAnchorClick);
      delete window.__lenis;
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#FDFBF7] text-[#2A1B14] overflow-x-hidden" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Menu />
        <GlutenFree />
        <Reviews />
        <Location />
      </main>
      <Footer />
      <MobileCallBar />
    </div>
  );
}

export default App;
